module.exports = __webpack_public_path__ + "img/investment.0757f080.svg";